(function() {
    var placeholder = document.getElementById('sidebar-placeholder');
    if (!placeholder) return;

    var lastScrollY = window.scrollY;
    var ticking = false;
    var stickyActive = false;
    var offset = 20;

    /**
     * Retrieves the current context from the placeholder.
     */
    function getContext() {
        try {
            return JSON.parse(placeholder.getAttribute('data-context') || '{}');
        } catch (e) {
            console.error('Invalid sidebar context', e);
            return {};
        }
    }

    /**
     * Loads sidebar content via REST API.
     */
    function loadSidebar(context, force) {
        // Option B: We only load on desktop (>= 768px)
        if (window.innerWidth < 768) return;
        
        // Always prevent concurrent loads
        if (placeholder.getAttribute('data-loading') === 'true') return;

        var isManualUpdate = !!context;
        
        // Prevent double loading if not a manual update or forced
        if (!force && !isManualUpdate && placeholder.getAttribute('data-loaded') === 'true') return;
        
        placeholder.setAttribute('data-loading', 'true');
        context = context || getContext();

        // Use localized REST URL from AssetsManager
        var restBase = (window.saborlistaAjax && window.saborlistaAjax.restUrl) || '/wp-json/';
        var endpoint = restBase + 'saborlista/v1/sidebar';
        
        var params = [];
        if (context.post_id) params.push('post_id=' + encodeURIComponent(context.post_id));
        if (context.term_id) params.push('term_id=' + encodeURIComponent(context.term_id));
        if (context.taxonomy) params.push('taxonomy=' + encodeURIComponent(context.taxonomy));
        if (context.special) params.push('special=' + encodeURIComponent(context.special));
        if (context.post_type) params.push('post_type=' + encodeURIComponent(context.post_type));
        
        var url = endpoint + (params.length ? '?' + params.join('&') : '');

        fetch(url)
            .then(function(response) { return response.json(); })
            .then(function(data) {
                if (data.html) {
                    placeholder.innerHTML = data.html;

                    // Trigger sticky calculation after content is injected
                    requestAnimationFrame(initSticky);
                } else {
                    placeholder.innerHTML = ''; // Clear skeleton if no widgets
                }
                placeholder.setAttribute('data-loaded', 'true');
                placeholder.removeAttribute('data-loading');
            })
            .catch(function(err) { 
                console.error('Sidebar load failed', err);
                placeholder.removeAttribute('data-loading');
            });
    }

    /**
     * Initializes sticky behavior.
     */
    function initSticky() {
        if (window.innerWidth < 768) {
            stickyActive = false;
            placeholder.classList.remove('is-sticky');
            placeholder.style.position = '';
            placeholder.style.top = '';
            placeholder.style.bottom = '';
            return;
        }

        // If we crossed to desktop but not loaded yet, try loading
        if (placeholder.getAttribute('data-loaded') !== 'true') {
            loadSidebar();
        }

        stickyActive = true;
        placeholder.classList.add('is-sticky');
        updateSticky();
    }

    /**
     * Updates sticky position based on scroll direction and height.
     */
    function updateSticky() {
        if (!stickyActive) return;

        var scrollY = window.scrollY;
        var viewportHeight = window.innerHeight;
        var rect = placeholder.getBoundingClientRect();
        var sidebarHeight = rect.height;
        
        var diff = scrollY - lastScrollY;
        
        // We need the parent container to know the bounds (usually #inner-content)
        var parent = placeholder.parentElement;
        if (!parent) return;

        if (sidebarHeight + offset * 2 <= viewportHeight) {
            // Sidebar fits in viewport - simple sticky to top
            placeholder.style.position = 'sticky';
            placeholder.style.top = offset + 'px';
            placeholder.style.transition = ''; // Restore default transitions
        } else {
            // Sidebar is taller than viewport
            // We want it to move with content until edges hit viewport boundaries
            
            // Get current sticky top (relative to viewport)
            // If not set, use rect.top as starting point
            var currentStickyTop = parseFloat(placeholder.style.top);
            if (isNaN(currentStickyTop)) {
                currentStickyTop = rect.top;
            }

            var newTop = currentStickyTop - diff;
            
            // Limits
            var minTop = viewportHeight - sidebarHeight - offset;
            var maxTop = offset;
            
            // Clamp
            if (newTop < minTop) newTop = minTop;
            if (newTop > maxTop) newTop = maxTop;
            
            placeholder.style.position = 'sticky';
            placeholder.style.top = newTop + 'px';
            
            // Disable transition for smooth 1:1 scrolling when updating top dynamically
            placeholder.style.transition = 'none';
        }

        lastScrollY = scrollY;
    }

    // Initial load
    loadSidebar();

    // Scroll listener with requestAnimationFrame for performance
    window.addEventListener('scroll', function() {
        if (!ticking && stickyActive) {
            window.requestAnimationFrame(function() {
                updateSticky();
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

    // Resize listener
    window.addEventListener('resize', function() {
        initSticky();
    }, { passive: true });

    // Infinite Scroll integration
    document.addEventListener('saborlista_post_changed', function(e) {
        if (e.detail && e.detail.post_id) {
             loadSidebar({ post_id: e.detail.post_id });
        }
    });

    // Handle internal content changes (e.g. images loading, accordion widgets)
    if (window.ResizeObserver) {
        var ro = new ResizeObserver(function() {
            if (stickyActive) updateSticky();
        });
        ro.observe(placeholder);
    }
})();
